import { createSlice } from '@reduxjs/toolkit';

const companySlice = createSlice({
    name: 'company',
    initialState: { currentCompanyUUID: '' },
    reducers: {
        setCurrentCompanyUUID: (state, action) => {
            state.currentCompanyUUID = action.payload;
        },
    },
});

export const { setCurrentCompanyUUID } = companySlice.actions;
export default companySlice.reducer;